import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Divider, Grid, CircularProgress } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CustomButton from "../../../components/common/CustomButton";
import CustomTextField from "../../../components/common/CustomTextField";
import CustomAutocomplete from '../../../components/common/CustomAutoComplete';
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import { getStates, getCities, getCountries } from "../../../services/CommonServices";
import { ENQUIRY_COMPANY_VIEW, ENQUIRY_COMPANY_UPDATE } from '../../../services/apiRoutes';
import CustomStyle from "../../../components/common/CustomStyle";


const companyValidationSchema = Yup.object({
    companyName: Yup.string().required("Company Name is required"),
    mobile: Yup.string().required("Mobile is required"),
    companyAdminId: Yup.string().required("company Admin is required"),
    email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
    website: Yup.string()
        .url("Invalid URL format")
        .required("Website is required"),
    companyUrl: Yup.string().required("Company URL is required"),
    defaultCompany: Yup.boolean(),
    address: Yup.string().required("Address is required"),
    addressLineOne: Yup.string().required("Address Line One is required"),
    countryId: Yup.number().required("Country is required"),
    stateId: Yup.number().required("State is required"),
    baseCurrency: Yup.number().required("base Currency is required"),
    cityId: Yup.number().required("City is required"),
    pincode: Yup.string().required("Pincode is required"),
    financialYearStart: Yup.string().required("financial Year Start required"),
    financialYearEnd: Yup.string().required("financial Year End required"),
    companyAdminId: Yup.string().required("company Admin is required"),

});

const UpdateEnquiryCompany = ({ handleClose, clientCompanyId, owner,
    currencyList,
    fetchData,
    setMessage,
}) => {

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const countriesData = await getCountries();
                setCountries(countriesData || []);
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };

        fetchCountries();
    }, []);

    const getCommonData = async () => {
        const getCountriesData = await getCountries();
        if (getCountriesData) {
            setCountries(getCountriesData);
        }
    }
    useEffect(() => {
        getCommonData();
    }, []);

    useEffect(() => {
        if (!clientCompanyId) return;

        const fetchData = async () => {
            try {
                const accessToken = sessionStorage.getItem('accessToken');

                const response = await axios.get(ENQUIRY_COMPANY_VIEW(clientCompanyId), {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,

                    },
                });

                setData(response?.data?.clientCompany);

                const companyData = response?.data?.clientCompany;
                setData(companyData);
                if (companyData?.country?.id) {
                    const stateData = await getStates({ id: companyData.country.id });
                    setStates(stateData || []);
                }
                if (companyData?.state?.id) {
                    const cityData = await getCities({ id: companyData.state.id });
                    setCities(cityData || []);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [clientCompanyId]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const accessToken = sessionStorage.getItem('accessToken');

            const response = await axios.put(ENQUIRY_COMPANY_UPDATE(clientCompanyId), values, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Lead Update successfully",
                    type: "success",
                });
                fetchData()
                setTimeout(() => {
                    handleClose()
                }, 3000)
                handleClose()


            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };

    const handleChangeCountry = async (newValue, setFieldValue) => {
        const countryId = newValue?.id || "";
        setFieldValue("countryId", countryId);
        setFieldValue("stateId", "");
        setFieldValue("cityId", "");
        setStates([]);
        setCities([]);

        if (countryId) {
            try {
                const stateData = await getStates({ id: countryId });
                setStates(stateData || []);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        }
    };

    const handleChangeState = async (newValue, setFieldValue) => {
        const stateId = newValue?.id || "";
        setFieldValue("stateId", stateId);
        setFieldValue("cityId", "");
        setCities([]);

        if (stateId) {
            try {
                const cityData = await getCities({ id: stateId });
                setCities(cityData || []);
            } catch (error) {
                console.error("Error fetching cities:", error);
            }
        }
    };
    return (
        <>
            <Box sx={{ mx: 'auto', mt: 0 }}>
                <Formik
                    initialValues={{
                        companyName: data?.companyName || '',
                        mobile: data?.mobile || '',
                        email: data?.email || '',
                        website: data?.website || '',
                        companyUrl: data?.companyUrl || '',
                        defaultCompany: data?.defaultCompany || '',
                        telephone: data?.telephone || '',
                        baseCurrency: parseInt(data?.baseCurrency || ''),
                        companyAdminId: parseInt(data?.companyAdminId || ''),
                        fax: data?.fax || '',
                        address: data?.address || '',
                        addressLineOne: data?.addressLineOne || '',
                        addressLineTwo: data?.addressLineTwo || '',
                        stateId: data?.stateId || '',
                        cityId: data?.cityId || '',
                        countryId: data?.countryId || '',
                        pincode: data?.pincode || '',
                        gstin: data?.gstin || '',
                        fiscalYearBeginMonth: data?.fiscalYearBeginMonth || '',
                        companyLogo: data?.companyLogo || '',
                        companyFooter: data?.companyFooter || '',
                        companySignStamp: data?.companySignStamp || '',
                        financialYearStart: data?.financialYearStart || '',
                        financialYearEnd: data?.financialYearEnd || '',
                    }}
                    validationSchema={companyValidationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                        <Form>
                            <Grid container spacing={1} style={CustomStyle.container}>
                                <Grid item xs={4} md={6}>
                                    <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                        Update Company
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} md={6} style={CustomStyle.buttonContainer}>
                                    <Box style={CustomStyle.buttonBox}>
                                        <CustomButton
                                            startIcon={<SaveRounded />}
                                            title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                            size="small"
                                            variant="contained"
                                            type="submit"
                                            disabled={isSubmitting}
                                        />

                                        <CustomButton
                                            startIcon={<ClearRounded />}
                                            title="Cancel"
                                            size="small"
                                            variant="contained"
                                            onClick={handleClose}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>

                            <Divider />
                            <Grid
                                container
                                spacing={1}
                                style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "5px" }}
                            >
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomAutocomplete
                                        options={owner}
                                        fieldLabel="company Admin"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={owner.find((option) => option.id === values.companyAdminId) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('companyAdminId', newValue ? newValue.id : '')
                                        }
                                        placeholder="company Admin"
                                        error={touched.companyAdminId && !!errors.companyAdminId}
                                        helperText={touched.companyAdminId && errors.companyAdminId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="companyName"
                                        fieldLabel="Company Name"
                                        value={values.companyName}
                                        onChange={handleChange}
                                        required={true}
                                        placeholder="Enter Company Name"
                                        error={touched.companyName && Boolean(errors.companyName)}
                                        helperText={touched.companyName && errors.companyName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        id="outlined-number"
                                        type="number"
                                        name="mobile"
                                        fieldLabel="Mobile"
                                        value={values.mobile}
                                        onChange={handleChange}
                                        required={true}
                                        placeholder="Enter Mobile"
                                        error={touched.mobile && Boolean(errors.mobile)}
                                        helperText={touched.mobile && errors.mobile}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="email"
                                        type="email"
                                        fieldLabel="Email"
                                        value={values.email}
                                        onChange={handleChange}
                                        required={true}
                                        placeholder="Enter Email"
                                        error={touched.email && Boolean(errors.email)}
                                        helperText={touched.email && errors.email}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="website"
                                        type="url"
                                        fieldLabel="Website"
                                        value={values.website}
                                        onChange={handleChange}
                                        required={true}
                                        placeholder="Enter Website"
                                        error={touched.website && Boolean(errors.website)}
                                        helperText={touched.website && errors.website}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="companyUrl"
                                        fieldLabel="Company URL"
                                        value={values.companyUrl}
                                        required={true}
                                        onChange={handleChange}
                                        placeholder="Enter Company URL"
                                        error={touched.companyUrl && Boolean(errors.companyUrl)}
                                        helperText={touched.companyUrl && errors.companyUrl}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="telephone"
                                        type="number"
                                        fieldLabel="Telephone"
                                        value={values.telephone}
                                        onChange={handleChange}
                                        placeholder="Enter Telephone"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="fax"
                                        fieldLabel="Fax"
                                        value={values.fax}
                                        onChange={handleChange}
                                        placeholder="Enter Fax"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomAutocomplete
                                        options={currencyList}
                                        fieldLabel="Currency"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={currencyList.find((option) => option.id === values.baseCurrency) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('baseCurrency', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Currency"
                                        error={touched.baseCurrency && !!errors.baseCurrency}
                                        helperText={touched.baseCurrency && errors.baseCurrency}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="address"
                                        fieldLabel="Address"
                                        value={values.address}
                                        onChange={handleChange}
                                        required={true}
                                        placeholder="Enter Address"
                                        error={touched.address && !!errors.address}
                                        helperText={touched.address && errors.address}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="addressLineOne"
                                        fieldLabel="Address Line One"
                                        value={values.addressLineOne}
                                        onChange={handleChange}
                                        required={true}
                                        placeholder="Enter Address Line One"
                                        error={touched.addressLineOne && !!errors.addressLineOne}
                                        helperText={touched.addressLineOne && errors.addressLineOne}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="addressLineTwo"
                                        fieldLabel="Address Line Two"
                                        value={values.addressLineTwo}
                                        onChange={handleChange}
                                        placeholder="Enter Address Line Two"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <CustomAutocomplete
                                        options={countries}
                                        fieldLabel="Country"
                                        required
                                        getOptionLabel={(option) => option?.title || ""}
                                        onChange={(e, newValue) => handleChangeCountry(newValue, setFieldValue)}
                                        value={countries.find((c) => c.id === values.countryId) || null}
                                        placeholder="Select Country"
                                        error={touched.countryId && Boolean(errors.countryId)}
                                        helperText={touched.countryId && errors.countryId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomAutocomplete
                                        options={states}
                                        fieldLabel="State"
                                        required
                                        getOptionLabel={(option) => option?.title || ""}
                                        onChange={(e, newValue) => handleChangeState(newValue, setFieldValue)}
                                        value={states.find((s) => s.id === values.stateId) || null}
                                        placeholder="Select State"
                                        error={touched.stateId && Boolean(errors.stateId)}
                                        helperText={touched.stateId && errors.stateId}
                                        disabled={!values.countryId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomAutocomplete
                                        options={cities}
                                        fieldLabel="City"
                                        required
                                        getOptionLabel={(option) => option?.title || ""}
                                        onChange={(e, newValue) => setFieldValue("cityId", newValue?.id || "")}
                                        value={cities.find((c) => c.id === values.cityId) || null}
                                        placeholder="Select City"
                                        error={touched.cityId && Boolean(errors.cityId)}
                                        helperText={touched.cityId && errors.cityId}
                                        disabled={!values.stateId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        type="number"
                                        name="pincode"
                                        fieldLabel="Pincode"
                                        value={values.pincode}
                                        onChange={handleChange}
                                        required={true}
                                        placeholder="Enter Pincode"
                                        error={touched.pincode && !!errors.pincode}
                                        helperText={touched.pincode && errors.pincode}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        name="gstin"
                                        fieldLabel="GSTIN"
                                        value={values.gstin}
                                        onChange={handleChange}
                                        placeholder="Enter GSTIN"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        type="month"
                                        name="fiscalYearBeginMonth"
                                        fieldLabel="Fiscal Year Begin Month"
                                        value={values.fiscalYearBeginMonth}
                                        onChange={handleChange}
                                        placeholder="Enter Fiscal Year Begin Month"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        type="date"
                                        name="financialYearStart"
                                        fieldLabel="Financial Year Start"
                                        value={values.financialYearStart}
                                        onChange={handleChange}
                                        placeholder="Enter financial Year Start"
                                        error={touched.financialYearStart && !!errors.financialYearStart}
                                        helperText={touched.financialYearStart && errors.financialYearStart}
                                        required={true}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <CustomTextField
                                        type="date"
                                        name="financialYearEnd"
                                        fieldLabel="Financial Year End"
                                        value={values.financialYearEnd}
                                        onChange={handleChange}
                                        placeholder="Enter financialYearEnd"
                                        error={touched.financialYearEnd && !!errors.financialYearEnd}
                                        helperText={touched.financialYearEnd && errors.financialYearEnd}
                                        required={true}

                                    />
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
        </>
    );
};

export default UpdateEnquiryCompany;

